import React, { useCallback, useEffect, useState } from 'react';
import api from '../../services/api';
import { formatDateTimeNl } from '../../utils/formatDateTime';

function todayAmsterdamInput() {
  try {
    return new Intl.DateTimeFormat('en-CA', {
      timeZone: 'Europe/Amsterdam',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    }).format(new Date());
  } catch {
    return new Date().toISOString().slice(0, 10);
  }
}

export default function MarketingXendySyncLogTab({ onOpen360 }) {
  const [date, setDate] = useState(todayAmsterdamInput);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [events, setEvents] = useState([]);
  const [pending, setPending] = useState([]);

  const load = useCallback(async (day) => {
    setLoading(true);
    setError('');
    try {
      const res = await api.get(`/marketing/popup/xendy/list-events?date=${encodeURIComponent(day)}`);
      setEvents(res.data?.events || []);
      setPending(res.data?.pending_followups || []);
    } catch (e) {
      setError(e.response?.data?.error || e.message);
      setEvents([]);
      setPending([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load(date);
  }, [date, load]);

  return (
    <div className="marketing-xendy-sync-log">
      <header className="marketing-xendy-sync-log__head">
        <div>
          <h3>Xendy sync-log</h3>
          <p className="muted">
            Per dag: welk e-mailadres op welke mail-lijst is gezet, en geplande browse/cart-syncs.
            Cart 01: Inkoop zet ~1u na stilte op de lijst; Xendy mailt daarna direct.
          </p>
          <p className="muted">
            Verkeerde browser↔e-mail-koppeling wissen: open de bezoeker in Attributie (detail) → Ontkoppel /
            Pop-up reset. Of tab Test shop.
          </p>
        </div>
        <label className="marketing-xendy-sync-log__date">
          Datum
          <input type="date" value={date} onChange={(e) => setDate(e.target.value)} />
        </label>
      </header>

      {error ? <p className="marketing-ig-error">{error}</p> : null}
      {loading ? <p className="muted">Laden…</p> : null}

      <section className="marketing-xendy-sync-log__section">
        <h4>Gepland (Inkoop → Xendy) op deze dag ({pending.length})</h4>
        {!loading && pending.length === 0 ? (
          <p className="muted">Geen openstaande follow-ups met sync-tijd op deze dag.</p>
        ) : null}
        {pending.length > 0 ? (
          <table className="marketing-xendy-sync-log__table">
            <thead>
              <tr>
                <th>Sync gepland</th>
                <th>E-mail</th>
                <th>Verwachte mail</th>
              </tr>
            </thead>
            <tbody>
              {pending.map((row) => (
                <tr key={`p-${row.id}`}>
                  <td>{formatDateTimeNl(row.scheduled_at)}</td>
                  <td>
                    {onOpen360 ? (
                      <button type="button" className="klanten360-open-btn" onClick={() => onOpen360(row.email)}>
                        {row.email}
                      </button>
                    ) : (
                      row.email
                    )}
                  </td>
                  <td className="muted">{row.hint}</td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : null}
      </section>

      <section className="marketing-xendy-sync-log__section">
        <h4>Op lijst gezet ({events.length})</h4>
        {!loading && events.length === 0 ? (
          <p className="muted">
            Nog geen logregels voor deze dag. Nieuwe syncs verschijnen hier vanaf nu.
          </p>
        ) : null}
        {events.length > 0 ? (
          <table className="marketing-xendy-sync-log__table">
            <thead>
              <tr>
                <th>Tijd</th>
                <th>E-mail</th>
                <th>Lijst / segment</th>
                <th>Bron</th>
                <th>Mail</th>
              </tr>
            </thead>
            <tbody>
              {events.map((ev) => (
                <tr key={ev.id}>
                  <td>{formatDateTimeNl(ev.created_at)}</td>
                  <td>
                    {onOpen360 ? (
                      <button type="button" className="klanten360-open-btn" onClick={() => onOpen360(ev.email)}>
                        {ev.email}
                      </button>
                    ) : (
                      ev.email
                    )}
                  </td>
                  <td>{ev.list_label}</td>
                  <td>{ev.source_label}</td>
                  <td className="muted">{ev.mail_hint}</td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : null}
      </section>
    </div>
  );
}
